import AxiosInstance from "../services/networkServices";

export const listBadges = async (payload) => {
    const res = await AxiosInstance.post(`/admin/badge`, payload);
    return res.data;
}

export const addBadge = async (payload) => {
    const res = await AxiosInstance.post(`/admin/badge/create`, payload);
    return res.data;
}

export const editBadge = async(payload) =>{
   const res = await AxiosInstance.post(`/admin/badge/update`, payload);
    return res.data;
}

export const deleteBadge = async (payload) => {
    const res = await AxiosInstance.post(`/admin/badge/delete`, payload);
    return res.data;
}

export const listBadgeTypes = async () => {
    const res = await AxiosInstance.post(`/admin/badge/type`);
    return res.data;
}
